import { LEVELS } from '@helpers';
import { notchTop } from '@components/frame';
import {
  SEARCH_HEIGHT,
  HEADER_TEXT_HEIGHT_BASE,
  TITLE_HEIGHT_BASE,
  SPACE_BETWEEN_TITLE_AND_SEARCH_BASE,
  NOTCH_TOP_FALLBACK,
} from '../constants';
import { HeaderDimensions, VisibilityFlags } from '@components/search/components/v2/types';

export const calculateHeaderDimensions = (noSearchScreen: boolean, hideTitleSection: boolean): HeaderDimensions => {
  const NOTCH_TOP = noSearchScreen ? 0 : notchTop || NOTCH_TOP_FALLBACK;
  const HEADER_TEXT_HEIGHT = noSearchScreen || hideTitleSection ? 0 : HEADER_TEXT_HEIGHT_BASE;
  const HEADER_HEIGHT = HEADER_TEXT_HEIGHT + NOTCH_TOP;
  const TITLE_HEIGHT = noSearchScreen || hideTitleSection ? 0 : TITLE_HEIGHT_BASE;
  const SPACE_BETWEEN_TITLE_AND_SEARCH = noSearchScreen || hideTitleSection ? 0 : SPACE_BETWEEN_TITLE_AND_SEARCH_BASE;
  const TOTAL_HEIGHT = HEADER_HEIGHT + SEARCH_HEIGHT + TITLE_HEIGHT;
  const TITLE_ANIMATION_POSITION = SEARCH_HEIGHT + SPACE_BETWEEN_TITLE_AND_SEARCH;
  const HEADER_ANIMATION_START = TITLE_ANIMATION_POSITION + 36;

  return {
    NOTCH_TOP,
    HEADER_TEXT_HEIGHT,
    HEADER_HEIGHT,
    TITLE_HEIGHT,
    SPACE_BETWEEN_TITLE_AND_SEARCH,
    TOTAL_HEIGHT,
    TITLE_ANIMATION_POSITION,
    HEADER_ANIMATION_START,
  };
};

export const getVisibilityFlags = ({
  inputFocused,
  showPlaceholder,
  searchValue,
  inputChanged,
  isAllLevel,
  level,
}: {
  inputFocused: boolean;
  showPlaceholder: boolean;
  searchValue: string;
  inputChanged: boolean;
  isAllLevel: boolean;
  level: string;
}): VisibilityFlags => ({
  showHistory: inputFocused && (inputChanged || !searchValue),
  showElements: showPlaceholder || inputFocused,
  hideModeSelector: inputFocused || isAllLevel || level === LEVELS.Tools,
});

export const isCloseToBottom = (nativeEvent: {
  layoutMeasurement: { height: number };
  contentOffset: { y: number };
  contentSize: { height: number };
}): boolean => {
  return nativeEvent.layoutMeasurement.height + nativeEvent.contentOffset.y >= nativeEvent.contentSize.height - 500;
};
